import { useDashToast as useToast } from '@dashhudson/dashing-ui/toast';

import { updateSentiment as updateSentimentRequest } from '@/apis/social-listening';
import { useSocialListening } from '@/app/socialListening/composables/useSocialListening';
import { useSocialListeningSentimentStore } from '@/stores/social-listening-sentiment';

interface SentimentOverridePost {
  source: string;
  sourceId: string;
  sentimentLabel?: string;
  organizationSentiment?: unknown;
}

function sourceAndIdFor(post: SentimentOverridePost) {
  return `${post.source}:${post.sourceId}`;
}

export function useSentimentOverride() {
  const { organizationId } = useSocialListening();
  const sentimentStore = useSocialListeningSentimentStore();
  const { addToast } = useToast({ life: 5000 });

  function isPending(post: SentimentOverridePost) {
    return sentimentStore.isPending(sourceAndIdFor(post));
  }

  async function updateSentiment(post: SentimentOverridePost, label: string) {
    const sourceAndId = sourceAndIdFor(post);
    sentimentStore.setPendingState(sourceAndId, true);
    try {
      const res = await updateSentimentRequest({
        organizationId: organizationId.value,
        sourceAndId,
        sentimentLabel: label,
      });
      post.sentimentLabel = label;
      post.organizationSentiment = res.data.organizationSentiment;
      addToast({
        severity: 'success',
        summary: 'Sentiment Update',
        message: 'Sentiment successfully adjusted',
      });
      return true;
    } catch {
      addToast({
        severity: 'error',
        summary: 'Sentiment Update',
        message: 'Something went wrong',
      });
      return false;
    } finally {
      sentimentStore.setPendingState(sourceAndId, false);
    }
  }

  return { updateSentiment, isPending };
}
